import { jsx as o } from "react/jsx-runtime";
import { useTheme as s } from "../../theme/ThemeProvider.js";
import { Toaster as a } from "sonner";
import { CircleCheckIcon as t, InfoIcon as n, TriangleAlertIcon as c, OctagonXIcon as m, Loader2Icon as i } from "lucide-react";
const g = ({ ...r }) => {
  const { resolvedMode: e } = s();
  return /* @__PURE__ */ o(
    a,
    {
      theme: e,
      className: "toaster group",
      icons: {
        success: /* @__PURE__ */ o(t, { className: "size-4" }),
        info: /* @__PURE__ */ o(n, { className: "size-4" }),
        warning: /* @__PURE__ */ o(c, { className: "size-4" }),
        error: /* @__PURE__ */ o(m, { className: "size-4" }),
        loading: /* @__PURE__ */ o(i, { className: "size-4 animate-spin" })
      },
      style: {
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)",
        "--border-radius": "var(--radius)"
      },
      toastOptions: {
        classNames: {
          toast: "cn-toast"
        }
      },
      ...r
    }
  );
};
export {
  g as Toaster
};
//# sourceMappingURL=sonner.js.map
